import { LOCALES } from "common/constants";
import { socialIcons } from "common/StringUtils";
import React from "react";
import { Accordion, Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { AiOutlineClose } from "react-icons/ai";
import { BiMinus } from "react-icons/bi";
import { BsArrowRight } from "react-icons/bs";
import { GrFormAdd } from "react-icons/gr";
import { useDispatch } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import { logOut } from "../../../../src/redux/auth/authSlice";

const OuterRightSidebar = ({
  showNavMenu,
  setShowNavMenu,
  user,
  language,
  openDropdown,
  setOpenDropdown,
  setShowModal,
}) => {
  const location = useLocation();
  const { t } = useTranslation();
  const dispatch = useDispatch();

  return (
    <div>
      {/* Sidebar */}
      <aside className="outer_sidebar">
        <nav
          className={`nav-menu pt-5 right-sidebar-menu shadow rightside-bar-accordian less-width-mobile rightside-bar-accordian ${
            showNavMenu ? "active" : ""
          }`}
        >
          <AiOutlineClose
            className="closebtn text-dark"
            color="orange"
            onClick={() => setShowNavMenu(false)}
          />
          <ul className="px-4 pdng_set">
            {user &&
              !location.pathname.includes("dashboard") &&
              !location.pathname.includes("instrumentbrada") &&
              !location.pathname.includes("function") &&
              !location.pathname.includes("funktion") && (
                <Link
                  className="logout-icons d-flex align-items-center"
                  style={{
                    fontWeight: "600",
                    color: "#535353",
                    fontSize: "17px",
                  }}
                  to={
                    language === LOCALES.EN_US
                      ? `/emaillogin?lang=${LOCALES.EN_US}`
                      : `/e-postinloggning?lang=${LOCALES.SV_SE}`
                  }
                >
                  {t("Go to Dashboard")}

                  <span className="custom-span">
                    {" "}
                    <BsArrowRight />
                  </span>
                </Link>
              )}
            <li>
              {/* <Link className="text-primary"> */}
              <Accordion defaultActiveKey="0" className="frontside">
                <Accordion.Item eventKey="7">
                  <Accordion.Header
                    onClick={() => {
                      setOpenDropdown({
                        ...openDropdown,
                        eventKey7: !openDropdown.eventKey7,
                      });
                    }}
                  >
                    <span> {t("Invozio")} </span>
                    {!openDropdown.eventKey7 ? (
                      <GrFormAdd size={25} className="minus"></GrFormAdd>
                    ) : (
                      <BiMinus size={25} className="plus"></BiMinus>
                    )}
                  </Accordion.Header>
                  <Accordion.Body>
                    <Link
                      to={
                        language === LOCALES.EN_US
                          ? `/about-invozio?lang=${LOCALES.EN_US}`
                          : `/om-invozio?lang=${LOCALES.SV_SE}`
                      }
                      className="dropdown-item p-0 sidebar_hovText"
                    >
                      {t("About Invozio")}
                    </Link>

                    <Link
                      to={
                        language === LOCALES.EN_US
                          ? `/contact-us?lang=${LOCALES.EN_US}`
                          : `/kontakta-oss?lang=${LOCALES.SV_SE}`
                      }
                      className="dropdown-item p-0 sidebar_hovText"
                    >
                      {t("Contact us")}
                    </Link>

                    <Link
                      to={
                        language === LOCALES.EN_US
                          ? `/how-works-invozio?lang=${LOCALES.EN_US}`
                          : `/hur-fungerar-invozio?lang=${LOCALES.SV_SE}`
                      }
                      className="dropdown-item p-0 sidebar_hovText"
                    >
                      {t("This is how it works")}
                    </Link>

                    <Link
                      to={
                        user
                          ? language === LOCALES.EN_US
                            ? `/dashboard/function?lang=${LOCALES.EN_US}`
                            : `/instrumentbrada/funktion?lang=${LOCALES.SV_SE}`
                          : language === LOCALES.EN_US
                          ? `/function?lang=${LOCALES.EN_US}`
                          : `/funktion?lang=${LOCALES.SV_SE}`
                      }
                      className="dropdown-item p-0 sidebar_hovText"
                    >
                      {t("Functions")}
                    </Link>

                    <Link
                      to={
                        user
                          ? language === LOCALES.EN_US
                            ? `/dashboard/faq?lang=${LOCALES.EN_US}`
                            : `/instrumentbrada/faq?lang=${LOCALES.SV_SE}`
                          : language === LOCALES.EN_US
                          ? `/faq?lang=${LOCALES.EN_US}`
                          : `/faq?lang=${LOCALES.SV_SE}`
                      }
                      className="dropdown-item p-0 sidebar_hovText"
                    >
                      {t("FAQ")}
                    </Link>

                    <Link
                      to="https://se.trustpilot.com/review/fakturanu.se?utm_medium=trustbox&utm_source=Horizontal"
                      target="_blank"
                      className="dropdown-item p-0 sidebar_hovText"
                    >
                      {t("Trustpilot")}
                    </Link>

                    <Link
                      to={
                        user
                          ? language === LOCALES.EN_US
                            ? `/dashboard/ambassador?lang=${LOCALES.EN_US}`
                            : `/instrumentbrada/ambassador?lang=${LOCALES.SV_SE}`
                          : language === LOCALES.EN_US
                          ? `/ambassador?lang=${LOCALES.EN_US}`
                          : `/ambassador?lang=${LOCALES.SV_SE}`
                      }
                      className="dropdown-item p-0 sidebar_hovText"
                    >
                      {t("Become an ambassador")}
                    </Link>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
              {/* </Link> */}
            </li>

            <li>
              <Accordion defaultActiveKey="0" className="frontside">
                <Accordion.Item eventKey="1">
                  <Accordion.Header
                    onClick={() => {
                      setOpenDropdown({
                        ...openDropdown,
                        eventKey1: !openDropdown.eventKey1,
                      });
                    }}
                  >
                    <span> {t("Invoicing without your own company")} </span>
                    {!openDropdown.eventKey1 ? (
                      <GrFormAdd size={25} className="minus"></GrFormAdd>
                    ) : (
                      <BiMinus size={25} className="plus"></BiMinus>
                    )}
                  </Accordion.Header>
                  <Accordion.Body>
                    <Link
                      className="sidebar_hovText"
                      to={
                        language === LOCALES.EN_US
                          ? `/invoice-without-company-or-business?lang=${LOCALES.EN_US}`
                          : `/fakturera-utan-foretag-eller-bolag?lang=${LOCALES.SV_SE}`
                      }
                    >
                      {t("Invoice without a company ")}
                    </Link>
                    <Link
                      className="sidebar_hovText"
                      to={
                        language === LOCALES.EN_US
                          ? `/invoice-as-consultant-salary?lang=${LOCALES.EN_US}`
                          : `/fakturera-som-konsult-lon?lang=${LOCALES.SV_SE}`
                      }
                    >
                      {t("Invoice as a consultant")}
                    </Link>
                    <Link
                      className="sidebar_hovText"
                      to={
                        language === LOCALES.EN_US
                          ? `/freelance-freelancing?lang=${LOCALES.EN_US}`
                          : `/frilans-frilansarbete?lang=${LOCALES.SV_SE}`
                      }
                    >
                      {t("Guide to freelancing and freelance work")}
                    </Link>
                    <Link
                      className="sidebar_hovText"
                      to={
                        language === LOCALES.EN_US
                          ? `/invoicing-as-an-individual_self-employed?lang=${LOCALES.EN_US}`
                          : `/fakturera-som-privatperson_egenanstalld?lang=${LOCALES.SV_SE}`
                      }
                    >
                      {t("Invoicing as an individual self-employed")}
                    </Link>
                    <Link
                      className="sidebar_hovText"
                      to={
                        language === LOCALES.EN_US
                          ? `/freelance-consultant-salary-invoice-without-a-company?lang=${LOCALES.EN_US}`
                          : `/frilans-konsult-lon-fakturera-utan-foretag?lang=${LOCALES.SV_SE}`
                      }
                    >
                      {t("Own business or invoicing without a company")}
                    </Link>
                    <Link
                      className="sidebar_hovText"
                      to={
                        language === LOCALES.EN_US
                          ? `/how-much-should-I-invoice-as-a-freelancer?lang=${LOCALES.EN_US}`
                          : `/hur-mycket-ska-jag-fakturera-som-frilansare?lang=${LOCALES.SV_SE}`
                      }
                    >
                      {t("How much can you invoice as a freelancer")}
                    </Link>

                    <Link
                      className="sidebar_hovText"
                      to={
                        user
                          ? language === LOCALES.EN_US
                            ? `/dashboard/health-insurance?lang=${LOCALES.EN_US}`
                            : `/instrumentbrada/sjukforsakring?lang=${LOCALES.SV_SE}`
                          : language === LOCALES.EN_US
                            ? `/health-insurance-main?lang=${LOCALES.EN_US}`
                            : `/sjukforsakring-huvud?lang=${LOCALES.SV_SE}`
                      }
                    >
                      {t("Health Insurance")}
                    </Link>

                    <Link
                      className="sidebar_hovText"
                      to={
                        user
                          ? language === LOCALES.EN_US
                            ? `/dashboard/pension?lang=${LOCALES.EN_US}`
                            : `/instrumentbrada/pension?lang=${LOCALES.SV_SE}`
                          : language === LOCALES.EN_US
                            ? `/pension?lang=${LOCALES.EN_US}`
                            : `/pension?lang=${LOCALES.SV_SE}`
                      }
                    >
                      {t("Pension")}
                    </Link>

                    <Link
                      className="sidebar_hovText"
                      to={
                        user
                          ? language === LOCALES.EN_US
                            ? `/dashboard/private-healthcare-insurance?lang=${LOCALES.EN_US}`
                            : `/instrumentbrada/privatvardsforsakring?lang=${LOCALES.SV_SE}`
                          : language === LOCALES.EN_US
                            ? `/private-healthcare-insurance?lang=${LOCALES.EN_US}`
                            : `/privatvardsforsakring?lang=${LOCALES.SV_SE}`
                      }
                    >
                      {t("Private care insurance")}
                    </Link>

                    <Link
                      className="sidebar_hovText"
                      to={
                        user
                          ? language === LOCALES.EN_US
                            ? `/dashboard/insurances?lang=${LOCALES.EN_US}`
                            : `/instrumentbrada/forsakring?lang=${LOCALES.SV_SE}`
                          : language === LOCALES.EN_US
                            ? `/insurance?lang=${LOCALES.EN_US}`
                            : `/forsakring?lang=${LOCALES.SV_SE}`
                      }
                    >
                      {t("Insurances")}
                    </Link>

                    <Link
                      className="sidebar_hovText"
                      to={
                        language === LOCALES.EN_US
                          ? `/working-as-a-freelancer-and-invoicing-without-tax-registration?lang=${LOCALES.EN_US}`
                          : `/att-jobba-som-frilansare-och-fakturera-utan-fskatt?lang=${LOCALES.SV_SE}`
                      }
                    >
                      {t("Working as a freelancer")}
                    </Link>
                    <Link
                      className="sidebar_hovText"
                      to={
                        language === LOCALES.EN_US
                          ? `/invoicing-without-company-2025?lang=${LOCALES.EN_US}`
                          : `/fakturering-utan-foretag-2025?lang=${LOCALES.SV_SE}`
                      }
                    >
                      {t("Invoice Without a Company 2025")}
                    </Link>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            </li>
            <li>
              <Accordion defaultActiveKey="0" className="frontside">
                <Accordion.Item eventKey="2">
                  <Accordion.Header
                    onClick={() => {
                      setOpenDropdown({
                        ...openDropdown,
                        eventKey2: !openDropdown.eventKey2,
                      });
                    }}
                  >
                    <span> {t("About self-employment")} </span>
                    {!openDropdown.eventKey2 ? (
                      <GrFormAdd size={25} className="minus"></GrFormAdd>
                    ) : (
                      <BiMinus size={25} className="plus"></BiMinus>
                    )}
                  </Accordion.Header>
                  <Accordion.Body>
                    {/* <Link to="/faq"> {t("Questions and answers")} </Link> */}
                    <Link
                      className="sidebar_hovText"
                      to={
                        language === LOCALES.EN_US
                          ? `/self-employment?lang=${LOCALES.EN_US}`
                          : `/egenanstallning?lang=${LOCALES.SV_SE}`
                      }
                    >
                      {t("This is self-employment")}
                    </Link>

                    <Link
                      className="sidebar_hovText"
                      to={
                        user
                          ? language === LOCALES.EN_US
                            ? `/dashboard/good-working-conditions?lang=${LOCALES.EN_US}`
                            : `/instrumentbrada/bra-arbetsvillkor?lang=${LOCALES.SV_SE}`
                          : language === LOCALES.EN_US
                          ? `/start-your-own-business-or-invoice-as-a-private-person?lang=${LOCALES.EN_US}`
                          : `/starta-eget-foretag-eller-fakturera-som-privatperson?lang=${LOCALES.SV_SE}`
                      }
                    >
                      {t("Good working conditions")}
                    </Link>

                    <Link
                      className="sidebar_hovText"
                      to={
                        language === LOCALES.EN_US
                          ? `/from-invoice-to-negotiation?lang=${LOCALES.EN_US}`
                          : `/fran-faktura-till-forhandling?lang=${LOCALES.SV_SE}`
                      }
                    >
                      {t("The negotiation call")}
                    </Link>
                    {/* <Link to="/ambassador"> {t("Become an ambassador")} </Link> */}
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            </li>
            <li>
              <Accordion defaultActiveKey="0" className="frontside">
                <Accordion.Item eventKey="3">
                  <Accordion.Header
                    onClick={() => {
                      setOpenDropdown({
                        ...openDropdown,
                        eventKey3: !openDropdown.eventKey3,
                      });
                    }}
                  >
                    <span> {t("Business solutions")} </span>
                    {!openDropdown.eventKey3 ? (
                      <GrFormAdd size={25} className="minus"></GrFormAdd>
                    ) : (
                      <BiMinus size={25} className="plus"></BiMinus>
                    )}
                  </Accordion.Header>
                  <Accordion.Body className="mb-3">
                    <Link
                      className="sidebar_hovText"
                      to={
                        language === LOCALES.EN_US
                          ? `/business?lang=${LOCALES.EN_US}`
                          : `/foretag?lang=${LOCALES.SV_SE}`
                      }
                      // to="/external-help-with-payroll-management"
                    >
                      {t("Payroll management of extra staff")}
                    </Link>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            </li>

            {user ? (
              <Link
                className="logout-icons dashbrd_icns"
                style={{
                  fontWeight: "600",
                  color: "#535353",
                  fontSize: "17px",
                }}
                to="/"
                onClick={() => dispatch(logOut())}
              >
                {t("Log out")}
              </Link>
            ) : (
              ""
            )}
            {(location.pathname === "/dashboard/invoice-tool" ||
              location.pathname === "/instrumentbrada/faktura-verktyg") && (
              <>
                <Button
                  variant="outline-primary mt-3"
                  className="bg-light d-none d-lg-block cit remove_css"
                  size="lg"
                  onClick={() =>
                    setShowModal({
                      show: true,
                    })
                  }
                >
                  {t("Close Invoice Tool")}
                </Button>
              </>
            )}

            <div className="dashboard-sidebar">
              <h6 className="text-primary social my-3" to="">
                {t("Social media")}
              </h6>
              <div className="social-groups d-flex align-items-center">
                {socialIcons?.links.map((linkItem, index) => (
                  <a
                    href={linkItem.link}
                    target="_blank"
                    key={index}
                    rel="noreferrer"
                    aria-label={linkItem?.ariaLabel}
                  >
                    {linkItem.iconWithRightSidebarClass}
                  </a>
                ))}
              </div>
            </div>
          </ul>
        </nav>
      </aside>
    </div>
  );
};

export default OuterRightSidebar;
